import destroy from './destroy';
import store from './store';
import show from './show';
import update from './update';
import all from './all';
import items from './items';
import markAsDone from './markAsDone';
import saveAsDraft from './saveAsDraft';
import showPurchaseEmailInformation from './showPurchaseEmailInformation';
import download from './download';
import showPdf from './showPdf';
import send from './send';
import unfinished from './unfinished';
import showUnfinished from './showUnfinished';
import destroyUnfinished from './destroyUnfinished';
import markAsCancel from './markAsCancel';
import updateDraft from './updateDraft';
// import markAsPendingExternal from './markAsPendingExternal';

export default {
  destroy,
  store,
  show,
  update,
  all,
  items,
  saveAsDraft,
  markAsDone,
  showPurchaseEmailInformation,
  download,
  showPdf,
  send,
  unfinished,
  showUnfinished,
  destroyUnfinished,
  markAsCancel,
  updateDraft,
  // markAsPendingExternal,
};



// WEBPACK FOOTER //
// ./src/app/services/purchase/index.js